import { render, staticRenderFns } from "./ControlBodyManager.vue?vue&type=template&id=060cd858&"
import script from "./ControlBodyManager.vue?vue&type=script&lang=js&"
export * from "./ControlBodyManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports